export enum FormSelection {
  Form = 'form',
  Label = 'label',
  Input = 'input',
  Help = 'help',
}
